export default "__VITE_ASSET__D7_xKnnI__"